import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Switch, Tooltip, Icon, Chip, Text, Divider } from '@Sage/hoi-poi-ui';
import FieldSelect from 'containers/components/Fields/Select';
import { getLiteral } from 'utils/getLiteral';
import './styles.scss';

const propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    schema: PropTypes.array.isRequired,
    defaultEnvironment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedEnvironment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleToggle: PropTypes.func.isRequired,
    isToggled: PropTypes.bool.isRequired,
};

const EnvironmentHeader = memo(
    ({
        defaultEnvironment,
        selectedEnvironment,
        schema,
        model,
        onChange,
        handleToggle,
        isToggled,
    }) => {
        const field = schema[0].tabFields[0];

        const selectValue = useMemo(() => {
            if (!model) return undefined;
            const id = String(model.entity?.[field.id.id?.toLowerCase()] ?? '');
            const desc = model.entity?.[field.id.description?.toLowerCase()] ?? '';
            if (!id || id === '-1') return undefined;
            return { value: id, label: desc };
        }, [model, field]);

        const onChangeEnvironment = useCallback(
            (option) => {
                onChange(field, { id: option?.value, description: option?.label });
            },
            [field, onChange],
        );

        const isDefault = defaultEnvironment === selectedEnvironment;

        return (
            <div className="ssm-company-environment">
                <div className="ssm-company-environment-title-container">
                    <FieldSelect
                        className="ssm-company-environment__select"
                        list="tblSucursales"
                        value={selectValue}
                        onChange={onChangeEnvironment}
                        isClearable={false}
                    />
                    <div className="ssm-company-environment__actions">
                        {selectedEnvironment ? (
                            isDefault ? (
                                <Tooltip
                                    placement="top"
                                    content={getLiteral('label_choose_environment_description')}
                                >
                                    <span>
                                        <Chip icon="infoOutlined" isActive isFilled>
                                            {getLiteral('label_default_environment_selected')}
                                        </Chip>
                                    </span>
                                </Tooltip>
                            ) : (
                                <div className="ssm-company-environment__toggle">
                                    <Text>{getLiteral('label_mark_as_default')}</Text>
                                    <Tooltip
                                        placement="top"
                                        content={getLiteral('label_choose_environment_description')}
                                    >
                                        <span>
                                            <Icon name="infoOutlined" />
                                        </span>
                                    </Tooltip>
                                    <Switch
                                        size="medium"
                                        checked={isToggled}
                                        onChange={handleToggle}
                                    />
                                </div>
                            )
                        ) : null}
                    </div>
                </div>
                <Divider />
            </div>
        );
    },
);

EnvironmentHeader.propTypes = propTypes;
export default EnvironmentHeader;
